export default "__VITE_ASSET__BnFLHk$B__"